// extracted by mini-css-extract-plugin
export default {"star":"Landing_star__tHD-I"};